<template>
    <div class="pt-5"><!--begin::Toolbar-->
        <div class="toolbar py-5 py-lg-15" id="kt_toolbar"><!--begin::Container-->
            <div id="kt_toolbar_container" class="d-flex flex-stack flex-wrap"><!--begin::Page title-->
                <div class="page-title d-flex flex-column me-3"><!--begin::Title-->
                    <h1 class="text-white text-bolder">{{ pageSettings.title }}</h1>
                    <!--end::Title--><!--begin::Breadcrumb-->
                    <ul class="breadcrumb breadcrumb-separatorless fw-bold fs-7 my-1"><!--begin::Item-->
                        <template
                        v-for="(item, index) in pageSettings.breadCrumbs"
                            :key="index"

                        >
                        <li
                            class="breadcrumb-item text-white opacity-75 p-0"
                        >
                            <a :href="item.href" class="text-white">{{ item.label }}</a>
                        </li><!--end::Item-->
                        <span v-if="index < pageSettings.breadCrumbs.length - 1" class="sprate text-white">-</span>
                        </template>
                    </ul><!--end::Breadcrumb-->
                </div><!--end::Page title--><!--begin::Actions-->
                <filter-box v-if="filters.length > 0" :filters="filters" @apply="apply"></filter-box>
            </div><!--end::Container-->
        </div><!--end::Toolbar-->
    </div>
</template>
<script>
import FilterBox from '@/components/shared/FilterBox'

export default {
    components: {FilterBox},
    props: {
        filters: {
            type: Array,
            required: true,
        },
        pageSettings: {
            type: Object,
            required: true,
        }
    },
    data() {
        return {
            form: {}
        }
    },
    methods: {
        apply() {
            window.table.draw()
        }
    },
};
</script>

<style lang="scss" >
.breadcrumb {
    .sprate {
        margin: 0px 5px; /* Adjust the margin as needed */
    }
}
</style>
